<template>
    <div class="score_bottom_bar" :class="{ show: show }">
        <div class="progress_wrap">
            <!-- 奖励按钮 -->
            <div class="prize_wrap">
                <div
                    class="prize_item p0"
                    :class="[lang, { active: prize1state }]"
                    @click="get300Reward"
                >
                    {{ $t('base.scorePrize.get_gift_one') }}
                </div>
                <div
                    class="prize_item p1"
                    :class="[lang, { active: prize2state }]"
                    @click="get600Reward"
                >
                    {{ $t('base.scorePrize.get_gift_two') }}
                </div>
                <div
                    class="prize_item p2"
                    :class="[lang, { active: prize3state }]"
                    @click="showLottery"
                >
                    {{ $t('base.scorePrize.draw') }}
                </div>
            </div>
            <!-- 进度条 -->
            <div class="progress_box">
                <div
                    class="progress_bar"
                    :style="'width: ' + (score / max) * 100 + '%'"
                >
                    <i></i>
                </div>
                <!-- 数值 -->
                <span
                    class="pointNum"
                    v-for="item in points"
                    :style="'left: ' + (item / max) * 100 + '%'"
                    :key="item"
                    >{{ item }}</span
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { Bus } from '@/utils/eventBus.js';
export default {
    name: 'scoreTopBar',
    props: {
        // 是否显示
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            points: [0, 300, 600, 1000], // 需要显示的分段数
            min: 80, // 进度条最小值，低于这个值时，显示固定长度，保证头尾显示完整
            max: 1100 // 进度条最大刻度1100（保证大于1000时能多出一截显示）
        };
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        },
        // 奖励可领取状态
        prize1state() {
            if (!this.$store.state.userinfo) return false;
            return this.$store.state.userinfo.get_gift_one == 1
                ? true
                : this.totalScore >= this.points[1];
        },
        prize2state() {
            if (!this.$store.state.userinfo) return false;
            return this.$store.state.userinfo.get_gift_two == 1
                ? true
                : this.totalScore >= this.points[2];
        },
        prize3state() {
            if (!this.$store.state.userinfo) return false;
            return this.score >= this.points[3];
        },
        // 总积分
        totalScore() {
            if (!this.$store.state.userinfo) return 0; // 未登录前，总积分设0
            return this.$store.state.userinfo.score_total;
        },
        // 未兑换积分
        score() {
            if (!this.$store.state.userinfo) return this.min; // 未登录前，未兑换积分（进度条）设为最小值
            // 登录后，设未兑换积分（小于进度条最小值则按最小值来显示，大于进度条最大值则按最大值来）
            return this.$store.state.userinfo.score <= this.min
                ? this.min
                : this.$store.state.userinfo.score >= this.max
                ? this.max
                : this.$store.state.userinfo.score;
        }
    },
    mounted() {},
    methods: {
        ...mapMutations([
            'SHOW_POPUP',
            'SET_LANG',
            'SET_STATE',
            'SHOW_CODE_POPUP',
            'PLAY_SOUND',
            'STOP_SOUND'
        ]),
        ...mapActions(['drawReward', 'showComm', 'getRewardList']),
        eventBusDemo() {
            Bus.$emit('_eventBusDemo');
        },
        // 领取300积分礼品
        async get300Reward() {
            this.PLAY_SOUND('button');
            if (this.prize1state) {
                const {
                    activeId300,
                    reward300Record,
                    userinfo
                } = this.$store.state;
                if (userinfo.get_gift_one == 2) {
                    this.drawReward(activeId300);
                } else {
                    if (reward300Record) {
                        this.SHOW_CODE_POPUP(reward300Record);
                    } else {
                        const result = await this.getRewardList({
                            page: 1,
                            size: 1,
                            active_id: activeId300
                        });
                        if (result.code == 1) {
                            const log = result.data[0];
                            this.SHOW_CODE_POPUP(log);
                            this.SET_STATE({
                                key: 'reward300Record',
                                val: log
                            });
                        }
                    }
                }
            } else {
                this.showComm({
                    text: this.$t('popup.noScoreTips'),
                    size: 'big',
                    hasCls: true,
                    hasDownload: true
                });
            }
        },
        // 领取600积分礼品
        async get600Reward() {
            this.PLAY_SOUND('button');
            if (this.prize2state) {
                const {
                    activeId600,
                    reward600Record,
                    userinfo
                } = this.$store.state;
                if (userinfo.get_gift_two == 2) {
                    this.drawReward(activeId600);
                } else {
                    if (reward600Record) {
                        this.SHOW_CODE_POPUP(reward600Record);
                    } else {
                        const result = await this.getRewardList({
                            page: 1,
                            size: 1,
                            active_id: activeId600
                        });
                        if (result.code == 1) {
                            const log = result.data[0];
                            this.SHOW_CODE_POPUP(log);
                            this.SET_STATE({
                                key: 'reward600Record',
                                val: log
                            });
                        }
                    }
                }
            } else {
                this.showComm({
                    text: this.$t('popup.noScoreTips'),
                    size: 'big',
                    hasCls: true,
                    hasDownload: true
                });
            }
        },
        showLottery() {
            this.PLAY_SOUND('button');
            this.SHOW_POPUP('lottery');
        }
    }
};
</script>

<style lang="less" scoped>
.score_bottom_bar {
    position: absolute;
    width: 100%;
    height: 206px;
    background: url('~@/assets/img/game/bg_score_bar.png') center no-repeat;
    background-size: cover;
    bottom: 0;
    left: 0;
    z-index: -1;
    transform: translate(0, 210px);
    transition: 0.5s;

    &.show {
        z-index: 2;
        transform: translate(0, 0);
    }

    .progress_wrap {
        width: 554px;
        height: 30px;
        background: url('~@/assets/img/game/progress_border.png') center
            no-repeat;
        background-size: cover;
        position: absolute;
        top: 110px;
        left: 50%;
        margin-left: -554/2px;

        .prize_wrap {
            position: absolute;
            width: 100%;

            .prize_item {
                position: absolute;
                height: 84px;
                font-size: 24px;
                top: -90px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                text-align: center;
                box-sizing: border-box;
                padding: 0 14px 12px;
                line-height: 28px;
                word-break: break-all;
                &.active {
                    color: #fff;
                }

                &.p0 {
                    left: 100px;
                    width: 155px;
                    background-image: url('~@/assets/img/game/prize_en_0_0.png');

                    &.active {
                        background-image: url('~@/assets/img/game/prize_en_0_1.png');
                    }

                    &.ru {
                        left: -14px;
                        width: 232px;
                        background-image: url('~@/assets/img/game/prize_ru_0_0.png');
                        &.active {
                            background-image: url('~@/assets/img/game/prize_ru_0_1.png');
                        }
                    }
                }
                &.p1 {
                    left: 260px;
                    width: 155px;
                    background-image: url('~@/assets/img/game/prize_en_1_0.png');

                    &.active {
                        background-image: url('~@/assets/img/game/prize_en_1_1.png');
                    }
                    &.ru {
                        left: 224px;
                        width: 232px;
                        background-image: url('~@/assets/img/game/prize_ru_1_0.png');
                        &.active {
                            background-image: url('~@/assets/img/game/prize_ru_1_1.png');
                        }
                    }
                }
                &.p2 {
                    left: 450px;
                    width: 95px;
                    background-image: url('~@/assets/img/game/prize_en_2_0.png');
                    &.active {
                        background-image: url('~@/assets/img/game/prize_en_2_1.png');
                    }

                    &.ru {
                        left: 460px;
                        width: 95px;
                        background-image: url('~@/assets/img/game/prize_ru_2_0.png');
                        &.active {
                            background-image: url('~@/assets/img/game/prize_ru_2_1.png');
                        }
                    }
                }
            }
        }

        .progress_box {
            position: absolute;
            width: 540px;
            height: 30px;
            top: 7px;
            left: 7px;

            .progress_bar {
                width: 0%;
                height: 16px;
                position: relative;
                box-sizing: border-box;
                border: 20px solid transparent;
                border-top-width: 0;
                border-bottom-width: 0;

                i {
                    display: block;
                    width: 100%;
                    height: 16px;
                    background: url('~@/assets/img/game/progress_bar_1.png')
                        center repeat-x;
                    background-size: auto 100%;
                }

                &:before,
                &:after {
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 16px;
                    background-repeat: no-repeat;
                    background-size: auto 100%;
                    background-position: center;
                    top: 0;
                }

                &:before {
                    left: -20px;
                    background-image: url('~@/assets/img/game/progress_bar_0.png');
                }
                &:after {
                    right: -20px;
                    background-image: url('~@/assets/img/game/progress_bar_2.png');
                }
            }

            .pointNum {
                position: absolute;
                width: 76px;
                font-size: 30px;
                color: #1f3c46;
                // background: #000;
                text-align: center;
                margin-left: -76/2px;
                font-weight: bold;
                top: 26px;
            }
        }
    }
}
</style>
